import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Bridge from "./pages/Bridge";
import Bokiori from "./pages/Bokiori";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/bridge" element={<Bridge />} />
      <Route path="/bokiori" element={<Bokiori />} />
    </Routes>
  );
}

export default App;
